import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

const DEFAULT_LABELS = Object.freeze([
  Object.freeze({ value: 1, label: 'Needs Improvement' }),
  Object.freeze({ value: 2, label: 'Inconsistent' }),
  Object.freeze({ value: 3, label: 'Consistent' }),
  Object.freeze({ value: 4, label: 'Strong' }),
  Object.freeze({ value: 5, label: 'Outstanding' }),
]);

// AU NSW uses a 3-point effort scale that maps onto stored values 1-3.
const AU_NSW_LABELS = Object.freeze([
  Object.freeze({ value: 1, label: 'Low' }),
  Object.freeze({ value: 2, label: 'Satisfactory' }),
  Object.freeze({ value: 3, label: 'High' }),
]);

export interface EffortLabel {
  readonly value: number;
  readonly label: string;
}

export function effortLabelsFor(
  jurisdiction: number | null | undefined,
): readonly EffortLabel[] {
  if (jurisdiction === Jurisdiction.AU_NSW) {
    return AU_NSW_LABELS;
  }
  return DEFAULT_LABELS;
}

export function effortLabelFor(
  value: string | number | null | undefined,
  jurisdiction: number | null | undefined,
): string | null {
  if (value == null || value === '') {
    return null;
  }
  const numeric = parseInt(value as string, 10);
  if (isNaN(numeric)) {
    return null;
  }
  const entry = effortLabelsFor(jurisdiction).find((e) => e.value === numeric);
  return entry ? entry.label : null;
}
